// removed by extract-text-webpack-plugin
module.exports = {"business-notif":"business-notif","business-notif-title":"business-notif-title","business-notif-view-all":"business-notif-view-all","view-all-link":"view-all-link","item-business-notif":"item-business-notif","item-business-notif-left-time":"item-business-notif-left-time","item-business-notif-time":"item-business-notif-time","item-business-notif-day":"item-business-notif-day","item-business-notif-right-desc":"item-business-notif-right-desc","view-detail":"view-detail"};


//////////////////
// WEBPACK FOOTER
// ./components/my-business/sub-view/the-news/notification/style.scss
// module id = ./components/my-business/sub-view/the-news/notification/style.scss
// module chunks = 0